"use strict";
if (document.querySelector(".rt-pop-announcement")) {
    import("./RTPop").then((e) => new e.default());
}
